

import React, { useState, useEffect } from 'react';

import '../styles/phcolours.css';

import useUIPresentationMode from '../helpers/useUIPresentationMode.js';


/*-------------------------------------------------------------------------------*/


const topButtonStyle = {
    padding: '9px 16px',
    fontSize: '16px',
    fontWeight: '600',
    border: 'none',
    borderRadius: '999px',
    cursor: 'pointer',
    background: 'var(--phblueaccentwashedwithtransparency)',
    color: 'var(--phblue)',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    boxShadow: 'var(--ph-box-shadow-nothover)',
    transition: 'all 0.2s ease-in-out',
};


/*-------------------------------------------------------------------------------*/


const UITopButtonsStock = ({ onZoomToAll, listingCount }) => {


    const { presentationModeSize } = useUIPresentationMode();
    const isVeryNarrowScreen = presentationModeSize >= 4;


    /*-----------------------------------------------------------------------------*/


    // Scale this mofo depending on screen size.
    const [scaleFactor, setScaleFactor] = useState(0.9);

    useEffect(() => {
        if (presentationModeSize === 1 || presentationModeSize === 2) {  // Big!
            setScaleFactor(1);
        }
        if (presentationModeSize === 3) {  // Not as big.
            setScaleFactor(0.9);
        }
        if (presentationModeSize === 4 || presentationModeSize === 5) {  // Little!
            setScaleFactor(0.9);
        }
    }, [presentationModeSize]);


    /*-----------------------------------------------------------------------------*/


    return (
        <>
            <div className="ui-top-buttons" style={{
                position: 'absolute',
                width: '90%',
                maxWidth: '720px',
                top: '15px',
                left: '50%',
                transform: `translate(-50%) scale(${scaleFactor})`,
                display: 'flex',
                alignItems: 'center',
                gap: isVeryNarrowScreen ? '13px' : '20px',
                zIndex: 1000,
                backgroundColor: 'transparent',
                whiteSpace: 'nowrap',
                flexWrap: 'wrap', // 🛠️ ALLOW wrapping on very narrow screens
                justifyContent: 'center',
                padding: '7px 35px',
            }}>

                <button
                    onClick={onZoomToAll}
                    style={topButtonStyle}
                    onMouseEnter={(e) => e.target.style.boxShadow = 'var(--ph-box-shadow-hover)'}
                    onMouseLeave={(e) => e.target.style.boxShadow = 'var(--ph-box-shadow-nothover)'}
                >
                    View All{" "}
                    {listingCount > 0 && (
                        <span style={{ fontWeight: 400, opacity: 0.7 }}>
                            ({listingCount})
                        </span>
                    )}
                </button>

            </div>
        </>
    );
};


export default UITopButtonsStock;



